(function () {
    const slider = document.querySelector('#occasion-slider');
    const gallery = document.querySelector('#occasion-gallery');

    if (slider === null || gallery === null) {
        return;
    }

    /**
     * Open the gallery in the correct position when clicking a slide.
     * @param {Event}
     */
    slider.addEventListener('slideclicked', ({ detail }) => {
        const { index } = detail;
        const gallerySlider = gallery.querySelector('swiper-slider');

        if (gallerySlider === null) {
            return true;
        }

        gallery.open = true;
        gallerySlider.slideTo(index + 1);
    });
})();



// WEBPACK FOOTER //
// ./scripts/custom/occasions/occasionDetailSlider.js